var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    d: "M15.281 8.181c0 4.422-3.028 7.569-7.5 7.569A7.74 7.74 0 0 1 .031 8 7.74 7.74 0 0 1 7.781.25c2.088 0 3.844.766 5.197 2.028l-2.11 2.028C8.11 1.644 2.979 3.644 2.979 8c0 2.703 2.16 4.894 4.803 4.894 3.069 0 4.219-2.2 4.4-3.34h-4.4V6.887h7.378a7 7 0 0 1 .122 1.293"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.031 0h15.25v16H.031z"
  })))));
};
export default SvgGoogle;